import { Box } from '@material-ui/core'
import "../../assets/style/home.css"
import FooterBg from "../../assets/img/footer-bg.png"
import IconFirst from "../../assets/img/hali-icon-1.png"
import { useMediaQuery } from '@material-ui/core'
import styled from 'styled-components'
import { FaTwitter, FaYoutube, FaInstagram, FaTelegram } from 'react-icons/fa'

export default function Footer() {
  const sm = useMediaQuery("(min-width: 600px)");
  return (
    <StyledContainer>
      <Box>
        <Box display={'flex'} justifyContent={'space-between'} mb={'90px'}>
          <img src={'/logo.png'} width={'215px'} height={'111px'} />
          <Box fontWeight={600} fontFamily={'Montserrat'}>
            <Box color={'#2ddd4d'} mt={'20px'}>Contact Us</Box>
            <HoverText color={'#ababab'}>info@reitoken.net</HoverText>
          </Box>
          <Box>
            <Box fontFamily={'Montserrat'} fontSize={'20px'} fontWeight={600} color={'white'}>Community</Box>
            <Socials mt={'10px'} ml={'10px'}>
              <a href={'https://twitter.com/OfficialREIT'} target={'_blank'} style={{ paddingRight: '30px' }}><FaTwitter /></a>
              <a href={'https://t.me/REITokenOfficial'} target={'_blank'}><FaTelegram /></a>
            </Socials>
            <HoverText color={'white'} mt={'40px'} >Privacy Policy</HoverText>
            <HoverText color={'white'} mt={'20px'}>Terms & Conditions</HoverText>
          </Box>
        </Box>
        <Box color={'#9c9c9c'} borderTop={'1px solid #373737'} pt={'10px'} textAlign={'center'}>
          Copyright © 2022. All rights reserved. REIT Token LLC
        </Box>
      </Box>
    </StyledContainer>
  )
}

const HoverText = styled(Box)`
  transition : all 0.3s;
  cursor : pointer;
  :hover{
    color : #376fdd;
  }
`;
const Socials = styled(Box)`
  display : flex;
  >a>svg{
    cursor : pointer;
    transition  : all 0.3s;
    color : rgb(55, 111, 221);
    font-size : 32px;
    :hover{
      color : #2ddd4d;
    }
  }
`;

const StyledContainer = styled(Box)`
  width : 100%;
  >div{
    max-width : 1100px;
    margin : 0 auto;
    padding : 110px 20px 70px;
    font-size : 14px;
  }
  @media screen and (max-width : 700px){
    >div>div:nth-child(1){
      flex-direction : column;
      >div{
        margin-top : 50px;
      }
    }
    padding-left : 50px;
  }
`;